import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ModalContainerHeaderStyled } from './../modalContainer.styled';
const HeaderContentComponent = React.forwardRef(({ hasScrolledPastTitle, headerTitle, title, header, styles }, ref) => {
    // so there is not an empty div in the DOM when there is no header or title
    if ((hasScrolledPastTitle && !headerTitle && !title) || (!hasScrolledPastTitle && !header)) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(ModalContainerHeaderStyled, { ref: ref, "$styles": styles, children: hasScrolledPastTitle ? headerTitle || title : header }));
});
HeaderContentComponent.displayName = 'HeaderContentComponent';
export const HeaderContent = HeaderContentComponent;
//# sourceMappingURL=headerContent.js.map